export default __webpack_public_path__ + "static/media/detail_mobile_12_4.57ce365d.jpg";